<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0 d-flex align-items-center justify-content-center">
      <b-col
        xs="12"
        sm="8"
        md="6"
        lg="4"
        class="d-flex align-items-center card p-5"
      >
        <ds-breeze-logo
          class="auth-logo"
          :height="28"
        />
        <b-col>
          <h1 class="auth-title">
            {{ $t('forgotPassword.title') }}
          </h1>
          <p class="auth-description">
            {{ $t('forgotPassword.description') }}
          </p>

          <ds-note
            v-if="submitted"
            variant="success"
            live="status"
          >
            {{ $t('forgotPassword.successMessage') }}
          </ds-note>

          <validation-observer
            v-if="!submitted"
            ref="forgotPasswordValidation"
          >
            <b-form @submit.prevent="handleSubmit">
              <div class="auth-field">
                <label
                  class="auth-label"
                  for="forgot-password-email"
                >{{ $t('forgotPassword.emailLabel') }}</label>
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <ds-input
                    id="forgot-password-email"
                    v-model.trim="email"
                    type="email"
                    name="forgot-password-email"
                    autocomplete="username"
                    :placeholder="$t('forgotPassword.emailPlaceholder')"
                    :invalid="errors.length > 0"
                    :aria-describedby="errors.length > 0 ? 'forgot-password-email-error' : null"
                  />
                  <div
                    id="forgot-password-email-error"
                    class="auth-error"
                    role="alert"
                  >
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <ds-button
                type="submit"
                class="auth-submit"
                :disabled="submitting"
              >
                {{ submitting ? $t('forgotPassword.submitting') : $t('forgotPassword.submit') }}
              </ds-button>
            </b-form>
          </validation-observer>

          <p class="auth-footer">
            <b-link :to="{ name: 'login' }">
              {{ $t('forgotPassword.backToLogin') }}
            </b-link>
          </p>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BForm, BLink,
} from 'bootstrap-vue'
import {
  DsBreezeLogo, DsButton, DsInput, DsNote,
} from '@/design-system/components'
import { required, email as emailRule } from '@validations'
import { userService } from '@/_services/user.service'

export default {
  components: {
    DsBreezeLogo,
    DsButton,
    DsInput,
    DsNote,
    BRow,
    BCol,
    BForm,
    BLink,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      email: '',
      submitting: false,
      submitted: false,
      required,
      emailRule,
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.forgotPasswordValidation.validate().then(success => {
        if (!success) return

        this.submitting = true

        userService.forgotPassword(this.email)
          .catch(() => {
            // Silently catch - we always show the same message for security
          })
          .finally(() => {
            this.submitting = false
            this.submitted = true
          })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>

<style lang="scss" scoped>
@import './auth-form';
</style>
